"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _warehouse = require("@/api/warehouse");
var _enum = require("@/utils/enum");
var _vuePropertyDecorator = require("vue-property-decorator");
var _moment = _interopRequireDefault(require("moment"));
var _reportExcel = require("./components/report-excel");
var _date = require("@/utils/date");
var _SelectDateModal = _interopRequireDefault(require("@/components/Shared/SelectDateModal.vue"));
var _reportConsignmentExcel = require("./components/report-consignment-excel");
var _utils = require("./components/utils");
var _report = require("@/types/report");
var ReportConsignment = /*#__PURE__*/function (_Vue) {
  function ReportConsignment() {
    var _this;
    (0, _classCallCheck2.default)(this, ReportConsignment);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, ReportConsignment, [].concat(args));
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "data", []);
    (0, _defineProperty2.default)(_this, "loading", false);
    (0, _defineProperty2.default)(_this, "query", {
      page: 1,
      limit: 10
    });
    (0, _defineProperty2.default)(_this, "total", 0);
    (0, _defineProperty2.default)(_this, "filters", {});
    (0, _defineProperty2.default)(_this, "tagOptions", _enum.tagOptions);
    (0, _defineProperty2.default)(_this, "date", [(0, _moment.default)().clone().startOf("year").format("YYYY-MM"), (0, _moment.default)().clone().endOf("month").format("YYYY-MM")]);
    (0, _defineProperty2.default)(_this, "loadingExcel", false);
    (0, _defineProperty2.default)(_this, "dataExport", []);
    (0, _defineProperty2.default)(_this, "ExportExcelType", _reportExcel.ExportExcelType);
    return _this;
  }
  (0, _inherits2.default)(ReportConsignment, _Vue);
  return (0, _createClass2.default)(ReportConsignment, [{
    key: "transformData",
    get: function get() {
      var data = (0, _utils.transformDataByCustomerExport)(this.data);
      return data;
    }
  }, {
    key: "monthRange",
    get: function get() {
      var fromDate = (0, _moment.default)(this.date[0], "YYYY-MM").format("DD.MM.YYYY");
      var toDate = (0, _moment.default)(this.date[1], "YYYY-MM").format("DD.MM.YYYY");
      var monthsInRange = (0, _utils.getMonthRange)(fromDate, toDate);
      return monthsInRange;
    }
  }, {
    key: "watchTabName",
    value: function watchTabName(val) {
      if (val == "report") {
        this.fetchData();
      }
    }
  }, {
    key: "created",
    value: function created() {
      this.fetchData();
    }
  }, {
    key: "getDataProductByMonth",
    value: function getDataProductByMonth(products) {
      var _this2 = this;
      return products.map(function (e, index) {
        var totalRemain = 0;
        var _loop = function _loop() {
          var month = _this2.monthRange[i].replace(".", "");
          var find = e.months.find(function (e) {
            return e.month == month;
          });
          e[month + "totalRemain"] = totalRemain;
          for (var _i = 0; _i < _report.listKeysReportConsign.length; _i++) {
            var key = _report.listKeysReportConsign[_i];
            e[month + key] = "--";
          }
          if (find) {
            for (var _i2 = 0; _i2 < _report.listKeysReportConsign.length; _i2++) {
              var _key2 = _report.listKeysReportConsign[_i2];
              e[month + _key2] = find[_key2];
            }
            e[month + "totalRemainBeforeReturn"] = find.totalRemainBeforeReturn + totalRemain;
            e[month + "totalRemain"] = find.totalRemain + totalRemain;
            totalRemain = find.totalRemain + totalRemain;
          }
        };
        for (var i = 0; i < _this2.monthRange.length; i++) {
          _loop();
        }
        return e;
      });
    }
  }, {
    key: "getExpired",
    value: function getExpired(date) {
      return (0, _date.diffDayFromToday)(date);
    }
  }, {
    key: "getPercentExpired",
    value: function getPercentExpired(data) {
      return (0, _date.percentFromCurrentToExpired)(data.expired, data.dateOfManufacture);
    }
  }, {
    key: "handleFilter",
    value: function handleFilter(filters) {
      this.query.page = 1;
      this.filters = filters;
      this.fetchData();
    }
  }, {
    key: "fetchData",
    value: function () {
      var _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var query;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.query.fromMonth = this.date[0];
              this.query.toMonth = this.date[1];
              this.loading = true;
              _context.prev = 3;
              query = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.query), this.filters);
              _context.next = 7;
              return this.fetchExportReportByCustomer(query);
            case 7:
              this.data = _context.sent;
            case 8:
              _context.prev = 8;
              this.loading = false;
              return _context.finish(8);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[3,, 8, 11]]);
      }));
      function fetchData() {
        return _fetchData.apply(this, arguments);
      }
      return fetchData;
    }()
  }, {
    key: "fetchExportReportByCustomer",
    value: function () {
      var _fetchExportReportByCustomer = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var extendQuery,
          query,
          res,
          _args2 = arguments;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              extendQuery = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
              query = (0, _objectSpread2.default)({}, extendQuery);
              _context2.next = 4;
              return _warehouse.warehouseApi.findReportConsignByCustomer(query);
            case 4:
              res = _context2.sent;
              return _context2.abrupt("return", res.data);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function fetchExportReportByCustomer() {
        return _fetchExportReportByCustomer.apply(this, arguments);
      }
      return fetchExportReportByCustomer;
    }()
  }, {
    key: "handleExportExcel",
    value: function handleExportExcel() {
      this.$refs.SelectDateModal.handleCreate();
    }
  }, {
    key: "handleSelectDateOk",
    value: function () {
      var _handleSelectDateOk = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3(_ref) {
        var startDate, endDate, fromMonth, toMonth, data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              startDate = _ref.startDate, endDate = _ref.endDate;
              fromMonth = startDate, toMonth = endDate;
              this.loadingExcel = true;
              _context3.next = 5;
              return this.fetchExportReportByCustomer({
                fromMonth: fromMonth,
                toMonth: toMonth
              });
            case 5:
              data = _context3.sent;
              this.loadingExcel = false;
              (0, _reportConsignmentExcel.exportReportByCustomerExcel)({
                data: data,
                fromDate: (0, _moment.default)(fromMonth).format("DD.MM.YYYY"),
                toDate: (0, _moment.default)(toMonth).format("DD.MM.YYYY")
              });
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function handleSelectDateOk(_x) {
        return _handleSelectDateOk.apply(this, arguments);
      }
      return handleSelectDateOk;
    }()
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("tabName")], ReportConsignment.prototype, "watchTabName", null);
ReportConsignment = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    SelectDateModal: _SelectDateModal.default
  }
})], ReportConsignment);
var _default = exports.default = ReportConsignment;